import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
import { CountdownTimer } from './CountdownTimer';
const valueItems = [{
  label: 'Semana 1 — Oferta + Copywriting',
  value: '$497'
}, {
  label: 'Semana 2 — Página + VSL',
  value: '$497'
}, {
  label: 'Semana 3 — Ads + Orgánico',
  value: '$497'
}, {
  label: 'Semana 4 — Optimización + Escalamiento',
  value: '$497'
}, {
  label: 'Bonos (Prompts + GPTs + Herramientas)',
  value: '$25,000+'
}, {
  label: 'BONO ESPECIAL: Reto de 30 Días Espiritual',
  value: '$297',
  isSpecial: true
}];
export function ValueStack() {
  return <section className="py-20 bg-gradient-to-b from-gray-50 to-white" data-id="element-251">
      <div className="max-w-4xl mx-auto px-6" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-253">
          <div className="inline-flex items-center gap-2 bg-black text-yellow-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-254">
            <Icon name="star" size={18} data-id="element-255" />
            Valor Total
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-8" data-id="element-256">
            Valor Total Real
          </h2>

          <div className="mb-8" data-id="element-257">
            <CountdownTimer data-id="element-258" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white border-2 border-gray-200 rounded-2xl p-8 md:p-12 mb-8" data-id="element-259">
          <div className="space-y-4 mb-8" data-id="element-260">
            {valueItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3 + index * 0.05
          }} className={`flex items-center justify-between py-4 border-b border-gray-200 last:border-0 ${item.isSpecial ? 'bg-gradient-to-r from-yellow-50 to-yellow-100 -mx-4 px-4 rounded-lg border-l-4 border-l-yellow-500' : ''}`} data-id="element-261">
                <div className="flex items-center gap-3" data-id="element-262">
                  <Icon name={item.isSpecial ? 'sparkles' : 'check'} size={20} className={item.isSpecial ? 'text-yellow-600' : 'text-green-500'} data-id="element-263" />
                  <span className={`font-medium ${item.isSpecial ? 'text-black font-bold' : 'text-gray-800'}`} data-id="element-264">
                    {item.label}
                  </span>
                </div>
                <span className={`font-bold ${item.isSpecial ? 'text-yellow-600' : 'text-black'}`} data-id="element-265">
                  {item.value}
                </span>
              </motion.div>)}
          </div>

          <div className="border-t-2 border-gray-300 pt-6" data-id="element-266">
            <div className="flex items-center justify-between mb-6" data-id="element-267">
              <span className="text-xl font-bold text-gray-800" data-id="element-268">
                Valor Total:
              </span>
              <span className="text-3xl font-extrabold text-black" data-id="element-269">
                $27,285
              </span>
            </div>

            <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 border-2 border-yellow-400 rounded-xl p-6 text-center" data-id="element-270">
              <div className="text-sm text-gray-600 uppercase tracking-wider mb-2" data-id="element-271">
                Pero por Black Friday…
              </div>
              <div className="text-5xl md:text-6xl font-extrabold text-black mb-2" data-id="element-272">
                $497 USD
              </div>
              <div className="text-gray-700 font-medium" data-id="element-273">
                El precio regular fue $997 y nunca baja… excepto hoy.
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-gradient-to-br from-red-50 to-orange-50 border-2 border-red-300 rounded-xl p-6 text-center" data-id="element-274">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-275">
            <Icon name="clock" size={24} className="text-red-600" data-id="element-276" />
            <span className="text-lg font-bold text-red-600 uppercase tracking-wider" data-id="element-277">
              Importante
            </span>
          </div>
          <p className="text-gray-800 font-medium" data-id="element-278">
            Este acceso NO se venderá después. Este precio NUNCA va a regresar.
          </p>
        </motion.div>
      </div>
    </section>;
}